/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface SimEventTemperatureActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /**
   * The temperature in degrees centigrade that will be adopted by the sim when this Action is
   * processed. E.g. temperature = 20.0 will cause the sim to set the environment temperature to
   * 20 degrees centigrade.
   */
  temperature: number;
}

function createBaseSimEventTemperatureActionArgs(): SimEventTemperatureActionArgs {
  return { trigger: undefined, temperature: 0 };
}

export const SimEventTemperatureActionArgs = {
  encode(message: SimEventTemperatureActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.temperature !== 0) {
      writer.uint32(21).float(message.temperature);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimEventTemperatureActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimEventTemperatureActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.temperature = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimEventTemperatureActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
    };
  },

  toJSON(message: SimEventTemperatureActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimEventTemperatureActionArgs>, I>>(base?: I): SimEventTemperatureActionArgs {
    return SimEventTemperatureActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimEventTemperatureActionArgs>, I>>(
    object: I,
  ): SimEventTemperatureActionArgs {
    const message = createBaseSimEventTemperatureActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.temperature = object.temperature ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
